import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Hero } from "@/components/home/Hero";
import { TrustedMarquee } from "@/components/home/TrustedMarquee";
import { NewBrandsSlider } from "@/components/home/NewBrandsSlider";
import { CategoryStrip } from "@/components/home/CategoryStrip";
import { Manifesto } from "@/components/home/Manifesto";
import { InstagramSection } from "@/components/home/InstagramSection";
import { CTABand } from "@/components/home/CTABand";
import { ServicesSection } from "@/components/home/ServicesSection";
import { Seo } from "@/components/seo/Seo";

export default function Home() {
  const [home, setHome] = useState(null);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    Promise.all([api.get("/homepage"), api.get("/categories")]).then(([h, c]) => { setHome(h.data); setCategories(c.data); });
  }, []);

  if (!home) return <div className="min-h-screen" />;
  const categoryMap = Object.fromEntries(categories.map((c) => [c.slug, c.name]));
  const sliderBrands = (() => {
    const list = [...(home.new_brands || [])];
    const sp = home.spotlight_brand;
    if (sp && !list.some((b) => b.slug === sp.slug)) list.unshift(sp);
    return list;
  })();

  return (
    <main data-testid="home-page">
      <Seo title="Deliver | Wholesale Food Distributor Sydney | Deli Meats, Cheese & Gourmet Ranges" description="Deliver is a Sydney based food distributor, wholesale food supplier and SQF accredited high care food processor supplying independent supermarkets, grocers, delis, cafes, restaurants and foodservice with premium Australian and imported food ranges." image={home.hero_image_url} />
      <Hero home={home} />
      <TrustedMarquee logos={home.trusted_logos} />
      <Manifesto home={home} part="mission" />
      <NewBrandsSlider brands={sliderBrands} label={home.spotlight_label} />
      <CategoryStrip categories={categories} />
      <Manifesto home={home} part="chapters" />
      <ServicesSection />
      <InstagramSection reels={home.instagram_reels} videos={home.reel_videos} heading={home.instagram_heading} />
      <CTABand />
    </main>
  );
}
